import ConfirmModal from '@components/modal/ConfirmModal';
import { useHistory } from 'react-router-dom';
import { FullUser } from 'src/types/shared/User';
import useDeleteUser from './hooks/useDeleteUser';

const DeleteUserModal: React.FC<DeleteUserProps> = ({ user }) => {
    const history = useHistory();
    const { handleSubmit, isPosting, error } = useDeleteUser(user.user.id);

    return (
        <ConfirmModal
            title="Delete admin"
            description={`Are you sure you want to delete '${user.user.firstName} ${user.user.lastName}'?`}
            closeModal={() => history.replace(`/users/${user.user.id}`)}
            handleSubmit={handleSubmit}
            isPosting={isPosting}
            error={error}
        />
    );
};

interface DeleteUserProps {
    user: FullUser;
}
export default DeleteUserModal;
